// ========================================================
// FAST HIT Website — Cookie & Analytics Consent Banner (Phase 9)
// Privacy-respecting opt-in banner for analytics telemetry
// ========================================================

import { useState, useEffect } from 'react';
import { Shield, Check, X } from 'lucide-react';
import { hasAnalyticsConsent, setAnalyticsConsent } from '../../services/analyticsService';
import './CookieConsentBanner.css';

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('fasthit_analytics_consent');
    if (!saved) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setAnalyticsConsent(true);
    setVisible(false);
  };

  const handleDecline = () => {
    setAnalyticsConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-bar" role="region" aria-label="Privacy and cookies notice">
      <div className="cookie-consent-container">
        <div className="cookie-text-wrap">
          <Shield size={18} className="cookie-icon text-cyan" />
          <p className="cookie-text">
            FAST HIT uses privacy-first, anonymized telemetry to optimize live scorecard latency
            and tournament discovery. We never sell your personal cricket data.
          </p>
        </div>

        <div className="cookie-actions">
          <button
            type="button"
            onClick={handleDecline}
            className="btn-consent-decline"
            aria-label="Decline analytics tracking"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="btn-consent-accept"
            aria-label="Accept analytics tracking"
          >
            <Check size={14} />
            <span>Accept</span>
          </button>
        </div>
      </div>
    </div>
  );
}
